import { useHistory, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import Loader from '../components/atoms/Loader';
import { AccountManager } from '@bluedolphin/util-module-mf';

/**
 * Index page component
 *
 * @returns {JSX.Element}
 */
export default function NotFound() {
    const history = useHistory();
    const { tenantId } = useParams<any>();

    useEffect(() => {
        if (!history.location.hash && history.location.pathname !== '/404') {
            const account = AccountManager.getTenant(tenantId);
            if (account && account.token) {
                AccountManager.setTenantName(tenantId);
                history.push(account.rootURL + account.landingPage);
            } else {
                history.push(`/${tenantId}/login`);
            }
        }
    }, []);

    if (history.location.hash) {
        return <Loader />;
    }

    return null;
}
